import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Flex,
  InputSearch,
  SearchContext,
  useScreenResolution,
} from 'dash-ui';

import FilterFields from './components/FilterFields/FilterFields';
import FilterDrawer from './components/FilterDrawer/FilterDrawer';

const TrackingPageHeader = () => {
  const { t } = useTranslation(['pages', 'common']);
  const { setSearchSlug } = useContext(SearchContext);
  const [inputValue, setInputValue] = useState('');
  const [isFilterOpened, setIsFilterOpened] = useState(false);
  const {
    devices: { isMobile },
  } = useScreenResolution();

  return (
    <Flex w="100%" justifyContent="space-between" alignItems="center">
      <InputSearch
        mr={2}
        placeholder={t('pages:propertyPage.searchProperty') || ''}
        value={inputValue}
        onClear={() => {
          setSearchSlug('');
          setInputValue('');
        }}
        onChange={(e) => {
          setInputValue(e.target.value);
          setSearchSlug(e.target.value);
        }}
        w="100%"
        maxWidth={401}
      />
      {isMobile ? (
        <Button
          icon="setting2"
          variation="outline"
          w={40}
          onClick={() => setIsFilterOpened(true)}
        />
      ) : (
        <FilterFields />
      )}
      {isFilterOpened && (
        <FilterDrawer onClose={() => setIsFilterOpened(false)} />
      )}
    </Flex>
  );
};

export default TrackingPageHeader;
